import clsx from 'clsx';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { LeftArrow } from '../../../icons/arrows/leftArrow';
import { CollapseIcon, ExpandIcon } from '../../../icons/expandIcon';
import { CarImageCard } from './CarImageCard';
import usePersonStore from '../../../store/personStore';
import { useDeliveryFlowStore } from '../../../store/newVehicleDeliveryStore';

export const DeliverySlider = () => {   

    const showRetailDashboard = usePersonStore(
        (store) => store.showRetailDashboard
    );

    const clearPersistedCarData = useDeliveryFlowStore((s) => s.clearPersistedCarData);
    
    // GLOBAL STATE:
    const carData = useDeliveryFlowStore((s) => s.carData);
    
    // LOCAL STATE:
    const plate = carData?.vehPlate ?? carData?.plateno;
    
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(true);

    return (
        // <div className={`max-lg:hidden sticky top-0 z-10 w-fit max-h-[83vh] ${state?.step === 0 && 'mt-[63px]'}`}>
        <div className={`max-lg:hidden sticky top-0 z-10 w-fit max-h-[83vh]`}>
            <div className="flex h-full mr-[30px]">
                <div
                    className={clsx(
                        'no-scrollbar overflow-y-scroll pt-6 px-12 bg-white rounded-r-[20px] h-[100%] transition-all ease-in-out duration-300',
                        expanded ? 'w-[374px]' : 'w-[40px]'
                    )}
                    style={{
                        boxShadow: '0px 2px 2px 2px #63636315',
                    }}
                >
                <div className={clsx('flex flex-col justify-between h-full transition-opacity', 
                    expanded ? 'opacity-100 delay-200 duration-150' : 'opacity-0 delay-0 duration-75 pointer-events-none select-none')}>
                    <div className='flex flex-col gap-3 pb-3'>
                        <div  className="flex gap-6 items-center hover:cursor-pointer mb-11"
                            onClick={()=> {
                                navigate(showRetailDashboard ? "/dashboard" : "/portal/my-cars")
                                clearPersistedCarData();
                                }} >
                            <LeftArrow />
                            <p className="text-subtitle text-[20px]">Επιστροφή στο My Cars</p>
                        </div>
                        <div className='flex flex-row justify-between items-center'>
                            <p className='text-sm font-bold'>{carData?.make ?? carData?.MakeName} {carData?.model ?? carData?.ModelName}</p>
                            <p className='text-sm font-bold'>{plate}</p>
                        </div>
                        {<CarImageCard size="extra-small" withDetails={false}/>}
                    </div>
                </div>
            </div>
            {expanded ? (
                <CollapseIcon
                onClick={() => {
                    setExpanded(!expanded);
                }}
                className={'hover:cursor-pointer h-full'}
                />
            ) : (
                <ExpandIcon
                onClick={() => {
                    setExpanded(!expanded);
                }}
                className={'hover:cursor-pointer h-full'}
                />
            )}
            </div>
        </div>
    );
};
